import axios from "axios"
import { Toast } from "vant"
import store from "@/store"

// 默认配置选项
const defaultOptions = {
  showLoading: true, // 是否显示loading
  showError: true, // 是否显示错误提示
}
// console.log('process.env.VUE_APP_API_URL :>> ', process.env.VUE_APP_API_URL);
// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL || '', // 基础URL，可以通过环境变量配置
  timeout: 20000, // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 获取请求配置选项
    const options = config.requestOptions || {}
    const mergedOptions = { ...defaultOptions, ...options }

    // 根据配置决定是否显示loading
    if (mergedOptions.showLoading) {
      Toast.loading({
        forbidClick: true,
        overlay: true,
        duration: 20000,
      })
    }

    const token = localStorage.getItem("token")
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`
    }
    if (config.headers) {
      console.log('localStorage.getItem("lang") :>> ', localStorage.getItem("lang"));
      const lang = localStorage.getItem('lang') || 'zh-CN'
      config.headers = {
        ...config.headers,
        "Content-Type": "application/json",
        'lang': lang === "zh-CN" ? "zh" : "en",
      }
    }
    return config
  },
  (error) => {
    // 对请求错误做些什么
    Toast.clear()
    console.error("Request error:", error)

    // 根据配置决定是否显示错误提示
    const options = error.config?.requestOptions || {}
    const mergedOptions = { ...defaultOptions, ...options }

    if (mergedOptions.showError) {
      Toast("请求发送失败")
    }
    return Promise.reject(error)
  },
)

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 获取请求配置选项
    const options = response.config.requestOptions || {}
    const mergedOptions = { ...defaultOptions, ...options }
    const { showLoginDialog = true, showLoading = true, hideLoading = false, showError = true } = mergedOptions

    // 根据配置决定是否清除loading
    if (showLoading && !hideLoading) {
      Toast.clear()
    }
    const res = response.data
    console.log('response :>> ', res);
    // 判断当前语言
    const savedLang = localStorage.getItem("lang") || "zh-CN"
    if (res.code !== 0) {
      const errorMsg = (savedLang === "zh-CN" ? res.msg : res.msgEn) || "Error"

      // 根据配置决定是否显示错误提示
      if (showError) {
        Toast.fail(errorMsg)
      }
      if (res.code === 401) {
        // token过期或无效，清除用户信息
        store.commit("auth/CLEAR_USER_INFO")
        
        showLoginDialog && store.commit("auth/SET_LOGIN_DIALOG_VISIBLE", true)
      }

      // 返回一个特殊的错误标识对象，而不是reject
      return Promise.reject(res)
    }

    return res
  },
  (error) => {
    // 获取请求配置选项
    const options = error.config?.requestOptions || {}
    const mergedOptions = { ...defaultOptions, ...options }

    const { showLoading = true, showError = true } = mergedOptions
    // 根据配置决定是否清除loading
    if (showLoading) {
      Toast.clear()
    }

    console.log("Response error:", error)

    let errorMsg = "网络连接错误"

    if (error.response) {
      switch (error.response.status) {
        case 401:
          errorMsg = "未授权，请重新登录"
          // token过期或无效，清除用户信息
          store.commit("auth/CLEAR_USER_INFO")
          break
        case 403:
          errorMsg = "拒绝访问"
          break
        case 404:
          errorMsg = "请求地址出错"
          break
        case 500:
          errorMsg = "服务器内部错误"
          break
        default:
          errorMsg = `连接错误${error.response.status}`
      }
    }

    if (error.code === 'ECONNABORTED') {
      // 判断当前语言
      const savedLang = localStorage.getItem("lang") || "zh-CN"
      savedLang === "zh-CN" ? errorMsg = "请求超时" : errorMsg = "Connection timeout"
    }
    // 根据配置决定是否显示错误提示
    if (showError) {
      Toast.fail({
        message: errorMsg,
        forbidClick: true,
        duration: 2500,
      })
    }
    // 返回错误标识对象，而不是reject
    return Promise.reject(error)
  },
)

/**
 * 封装的请求方法
 * @param {Object} config - axios请求配置
 * @param {Object} options - 请求选项配置
 * @param {boolean} options.showLoading - 是否显示loading，默认true
 * @param {boolean} options.showError - 是否显示错误提示，默认true
 */
const request = (config, options = {}) => {
  // 将options合并到config中，供拦截器使用
  const requestConfig = {
    ...config,
    requestOptions: options,
  }
  return service(requestConfig)
}

export default request
